// @owners { team: patients }
import { Body, Card, Column, H1, LgPadding, MdSpacing } from '@alto/design-system';
import * as React from 'react';

type Props = {
  readonly headerIcon?: React.ReactElement;
  readonly title?: string;
  readonly text?: string;
  readonly children: React.ReactElement | React.ReactElement[];
};

export const CommsVerificationCard = ({ headerIcon, title, text, children }: Props) => {
  return (
    <Card>
      <LgPadding>
        <Column
          left
          gap="SM"
        >
          {headerIcon}
          {title ? <H1>{title}</H1> : null}
          {text ? <Body>{text}</Body> : null}
        </Column>
        <MdSpacing />
        <Column
          centerHorizontally
          gap="SM"
        >
          {children}
        </Column>
      </LgPadding>
    </Card>
  );
};
